<template>
  <b-navbar toggleable navbar-default navbar-fixed-top>
    <!-- <b-navbar toggleable type="inverse" variant="success"> -->
    <b-nav-toggle target="nav_collapse" ></b-nav-toggle>

    <b-link class="navbar-brand" to="/">
      <span>
      <img src="../assets/logo_handson_sm.png">
      <img src="../assets/logo_eit_sm.png">
      </span>
    </b-link>
    <b-collapse is-nav id="nav_collapse">
      <!-- <b-nav is-nav-bar>
        <b-nav-item-dropdown text="Admin">
          <b-dropdown-item to="/users">UserOverview</b-dropdown-item>
          <b-dropdown-item to="/test/upload">Upload Test</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-nav> -->
      <b-nav is-nav-bar>
        <b-nav-item-dropdown v-if="privAdministrator" text="Manage">
          <b-dropdown-item to="/countries">Countries</b-dropdown-item>
          <b-dropdown-item to="/programs">Programs</b-dropdown-item>
          <b-dropdown-item to="/universities">Universities</b-dropdown-item>
          <b-dropdown-item to="/studentfees">Student Fees</b-dropdown-item>
          <b-dropdown-item to="/milestones">Milestones</b-dropdown-item>
          <b-dropdown-item to="/events">Log Events</b-dropdown-item>
          <b-dropdown-item to="/config">Configuration</b-dropdown-item>
          <b-dropdown-item to="/users">Users</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-nav>
      <b-nav is-nav-bar>
        <b-nav-item-dropdown text="Students">
          <b-dropdown-item to="/students">Students Overview</b-dropdown-item>
          <b-dropdown-item to="/contracts">Contracts Overview</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-nav>
      <b-nav is-nav-bar>
        <b-nav-item-dropdown text="Invoicing">
          <b-dropdown-item to="/invoices/planned">Planned Invoices</b-dropdown-item>
          <b-dropdown-item to="/invoices/numbered">Numbered Invoices</b-dropdown-item>
          <b-dropdown-item to="/invoices/creditnote">Credit Notes</b-dropdown-item>
          <b-dropdown-item to="/invoicepayments">Invoice Payments</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-nav>
      <b-nav is-nav-bar>
        <b-nav-item-dropdown text="Payments">
          <b-dropdown-item to="/scholarshippayments/planned">Planned Payments</b-dropdown-item>
          <b-dropdown-item to="/scholarshippayments/numbered">Numbered Payments</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-nav>

      <b-nav is-nav-bar class="ml-auto">
      </b-nav>

    </b-collapse>
    <p class="userinfo">{{userInfo}}</p>
    <p class="versioninfo">{{versionInfo}}</p>
    <b-button variant="default" size="sm" @click="$auth.logout();$router.push('/login')">
        <i class="fa fa-sign-out"></i>
    </b-button>
  </b-navbar>
</template>

<script>
import PrivilegeMixin from './PrivilegeMixin'

export default {
  name: 'BarTop',
  // components: {},
  mixins: [PrivilegeMixin],
  // data () {
  //   return {
  //   }
  // },
  computed: {
    userInfo () { return this.$auth.user().usr_name + ' [' + this.$auth.user().userrole_name + ']' },
    versionInfo () {
      // if (privAdministrator)
      //   return process.BRANCH + ' ' + process.VERSION
      // else
      return process.VERSION
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// BarTop.vue?0478ef60